import React, { useState } from "react";
import "./App.css";

import Toolbar from "./components/Toolbar/Toolbar";
import SideDrawer from "./components/SideDrawer/SideDrawer";
import Backdrop from "./components/Backdrop/Backdrop";
import Footer from "./components/Footer/Footer";
import FrontPage from "./components/Pages/FrontPage";
import Sjukrathjalfun from "./components/Pages/Sjukrathjalfun";
import Gjaldskra from "./components/Pages/Gjaldskra";
import UmOkkur from "./components/Pages/UmOkkur";
import Starfsfolk from "./components/Pages/Starfsfolk";
import Einstaklingur from "./components/Pages/Einstaklingur";
import Stadsetning from "./components/Pages/Stadsetning.js";
import Frettir from "./components/Pages/Frettir";
import Personuvernd from "./components/Pages/Personuvernd";
import TimaForm from "./components/Pages/TimaForm";
import News from "./components/Pages/News";
import Page404 from "./components/Pages/Page404.js";

import {
	BrowserRouter as Router,
	Routes,
	Route,
	Navigate,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import CookieContainer from "./components/Pages/CookieContainer/CookieContainer";
import "./components/Pages/Pages.css";

function App() {
	const [sideDrawerOpen, setSideDrawerOpen] = useState(false);

	const drawerToggleClickHandler = () => {
		setSideDrawerOpen((prev) => !prev);
	};

	const backdropClickHandler = () => {
		setSideDrawerOpen(false);
	};

	return (
		<Router>
			<ScrollToTop />
			<div className="appShell">
				<Toolbar drawerClickHandler={drawerToggleClickHandler} />
				<SideDrawer
					show={sideDrawerOpen}
					click={backdropClickHandler}
				/>
				{sideDrawerOpen && <Backdrop click={backdropClickHandler} />}
				<main style={{ paddingTop: "80px" }}>
					<Routes>
						<Route path="/" element={<FrontPage />} />

						<Route path="/sjukrathjalfun" element={<Sjukrathjalfun />} />
						<Route path="/sjukrathjalfun/gjaldskra" element={<Gjaldskra />} />

						<Route path="/starfsfolk" element={<Starfsfolk />} />
						<Route path="/starfsfolk/:id" element={<Einstaklingur />} />

						<Route path="/umokkur" element={<UmOkkur />} />

						<Route path="/umokkur/stadsetning" element={<Stadsetning />} />
						<Route path="/umokkur/personuvernd" element={<Personuvernd />} />

						<Route path="/frettir" element={<Frettir />} />
						<Route path="/frettir/:id" element={<News />} />

						<Route path="/timabokun" element={<TimaForm mode="bokun" />} />
						<Route path="/afbokun" element={<TimaForm mode="afbokun" />} />

						{/* the old contact url stays alive for existing links */}
						<Route
							path="/hafasamband"
							element={<Navigate to="/timabokun" replace />}
						/>

						<Route path="*" element={<Page404 />} />
					</Routes>
				</main>
				<Footer />
				<CookieContainer />
			</div>
		</Router>
	);
}

export default App;
